import { Modal } from "bootstrap";

const setupShowCallUsModal = () => {
  window.addEventListener("load", () => {
    const ctaModal = document.getElementById("ctaModal");
    if (!ctaModal) return;
    const callUsModal = new Modal(ctaModal);

    if (window.location.hash == "#call-us") {
      callUsModal.show();
    }
  });

  const ctaModalBtn = document.querySelectorAll(".cta-full-width__cta");

  for (let index = 0; index < ctaModalBtn.length; index++) {
    ctaModalBtn[index].addEventListener("click", () => {
      window.location = "#call-us";
    });
  }
};

export default setupShowCallUsModal;
